import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCalculationPeriodRegime } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const PeriodRegimeSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCalculationPeriodRegime, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCalculationPeriodRegime)}
			getOptionLabel={(option) => intl.formatMessage({ id: `PERIOD_REGIME_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default PeriodRegimeSelect;
